import React from 'react';
import styles from './moderation-pending-cards.module.scss';
import { Typography } from '@/ui-kit';
import { ModerationPendingIcon } from '@/assets/icons';

interface Props {}

export const ModerationPendingCards: React.FC<Props> = () => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <ModerationPendingIcon
                    className={styles.remoderationCardIcon}
                    width={56}
                    height={56} />
                <Typography
                    fontWeight="bold"
                    typeColor="white"
                    className={styles.title}
                    fontFamily="SFProText"
                    center>
                    Твоя анкета на проверке
                </Typography>
                <Typography
                    typeColor="white"
                    fontFamily="SFProText"
                    center
                    className={styles.text}
                    fontWeight="normal">
                    Сейчас проверяем твои данные, обычно это занимает немного времени
                </Typography>
            </div>
        </div>
    );
};
